import { useCallback } from "react";
import { CheckInService } from "../services/checkInService";
import { CheckInFilters, UserCheckIn } from "../types/checkin";
import { usePaginatedResource } from "./usePaginatedResource";

// No-ops when userId is null (invalid route param).
export const useUserCheckIns = (userId: number | null) => {
  const fetcher = useCallback(
    (page: number, filters: CheckInFilters) =>
      CheckInService.getUserCheckIns(userId as number, page, filters),
    [userId]
  );

  const { items, ...rest } = usePaginatedResource<UserCheckIn, CheckInFilters>(
    fetcher,
    {
      enabled: !!userId,
      errorMessage: "Failed to fetch check-ins",
    }
  );

  return { checkIns: items, ...rest };
};
